import { render } from "./TreeDemo.vue?vue&type=template&id=700e7f2b"
import script from "./TreeDemo.vue?vue&type=script&lang=js"
export * from "./TreeDemo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__